// @ts-nocheck
import { gql } from '__generated__'

export const GET_WALLET_CHALLENGE = gql(`
  query getWalletChallenge($walletAddress: String!) {
    getWalletChallenge(data: { walletAddress: $walletAddress }) {
      challenge
    }
  }
`)
